import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import { ExpandMoreOutlined } from "@material-ui/icons";

const GridOverlayAccordion = ({ title, content }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreOutlined />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <h6 className="text-base p-0 m-0 font-bold">{title}</h6>
      </AccordionSummary>
      <AccordionDetails>
        <p className="text-sm leading-tight  ">{content}</p>
      </AccordionDetails>
    </Accordion>
  );
};

export default GridOverlayAccordion;
